import React, { useEffect, useRef } from 'react';

interface AdBannerProps {
  adSlot: string;
  adClient: string;
  adFormat?: string;
  className?: string;
  height?: string | number;
  maxHeight?: string | number;
}

const AdBanner: React.FC<AdBannerProps> = ({ 
  adSlot, 
  adClient, 
  adFormat = 'auto', 
  className = '',
  height,
  maxHeight
}) => {
  const adRef = useRef<HTMLDivElement>(null);
  const scriptLoaded = useRef(false);

  useEffect(() => {
    // 確保 AdSense 腳本只加載一次
    if (!scriptLoaded.current && typeof window !== 'undefined') {
      // 檢查腳本是否已經存在
      const existingScript = document.querySelector(`script[src*="adsbygoogle.js"]`);
      
      if (!existingScript) {
        const script = document.createElement('script');
        script.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${adClient}`;
        script.async = true;
        script.crossOrigin = 'anonymous';
        script.id = 'google-adsense-script';
        document.head.appendChild(script);
        
        script.onload = () => {
          scriptLoaded.current = true;
          // 腳本加載後推送廣告
          if (adRef.current && window.adsbygoogle) {
            (window.adsbygoogle = window.adsbygoogle || []).push({});
          }
        };
      } else {
        scriptLoaded.current = true;
        // 腳本已存在，直接推送廣告
        if (adRef.current && window.adsbygoogle) {
          (window.adsbygoogle = window.adsbygoogle || []).push({});
        }
      }
    } else if (scriptLoaded.current && adRef.current && window.adsbygoogle) {
      // 如果腳本已加載，直接推送廣告
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    }

    // 清理函數
    return () => {
      // 不需要移除腳本，因為它可能被其他 AdBanner 組件使用
      // 只需確保不會重複加載
    };
  }, [adClient]);

  // 構建樣式對象
  const adStyle: React.CSSProperties = {
    display: 'block',
  };

  // 如果提供了高度，添加到樣式中
  if (height) {
    adStyle.height = typeof height === 'number' ? `${height}px` : height;
  }

  // 如果提供了最大高度，添加到樣式中
  if (maxHeight) {
    adStyle.maxHeight = typeof maxHeight === 'number' ? `${maxHeight}px` : maxHeight;
    adStyle.overflow = 'hidden';
  }

  return (
    <div className={`ad-container my-6 ${className}`}>
      <ins
        ref={adRef as any}
        className="adsbygoogle"
        style={adStyle}
        data-ad-client={adClient}
        data-ad-slot={adSlot}
        data-ad-format={adFormat}
        data-full-width-responsive="true"
      />
    </div>
  );
};

export default AdBanner; 